import { useEffect, useState } from "react";
export var useExperiment = function (experimentId) {
    var _a = useState(), variant = _a[0], setVariant = _a[1];
    useEffect(function () {
        var intervalId = setInterval(function () {
            if (window.google_optimize !== undefined) {
                setVariant(window.google_optimize.get(experimentId));
                clearInterval(intervalId);
            }
        }, 100);
        return function () {
            clearInterval(intervalId);
        };
    }, []);
    return variant;
};
//# sourceMappingURL=useExperiment.js.map